import React, {useEffect, useState} from "react";
import Table from "../../../components/Table/Table";
import {Bounce, toast} from "react-toastify";
import SearchTicketModal from "../../../components/SearchTicketModal/SearchTicketModal";
import {useGetEquipments} from "../../../hooks/Administrative/useGetEquipments";
import {useGetComponentsForEquipments} from "../../../hooks/Administrative/useGetComponentsForEquipments";
import './AdministrativeEquipments.css'
import {useSaveEquipment} from "../../../hooks/Administrative/useSaveEquipment";
import {useGetEquipmentByUniqueCode} from "../../../hooks/Administrative/useGetEquipmentByUniqueCode";
import {useUpdateEquipment} from "../../../hooks/Administrative/useUpdateEquipment";
import FilterTicketModal from "../../../components/FilterTicketModal/FilterTicketModal";
import FilterEquipmentsModal from "../../../components/FilterEquipmentsModal/FilterEquipmentsModal";

const columns = ['PLANTA', 'CLIENTE','DOSIFICADOR','ADITIVO'];

const AdministrativeEquipments = () => {

    const [filters, setFilters] = useState({});

    const {equipments, totalPages, isLoading, page, setPage, addEquipmentLocally, updateEquipmentLocally} = useGetEquipments({filters});

    const {dispenser, controller, tank, agitator, additives, clients} = useGetComponentsForEquipments();

    const handleFilterModal = (newFilters: object) => {
        setFilters(newFilters);
        setPage(0);
    };

    const { saveNewEquipment, savingNewEquipment } = useSaveEquipment();

    const [showAddEquipment, setShowAddEquipment] = useState(false);
    const [isConfirmDisabled, setIsConfirmDisabled] = useState(true);

    const [newEquipmentDispenser, setNewEquipmentDispenser] = useState("");
    const [newEquipmentController, setNewEquipmentController] = useState<any>("");
    const [newEquipmentAgitator, setNewEquipmentAgitator] = useState<any>("");
    const [newEquipmentTank, setNewEquipmentTank] = useState<any>("");
    const [newEquipmentAdditives, setNewEquipmentAdditives] = useState<any>("");
    const [selectedClient, setSelectedClient] = useState("");
    const [newEquipmentPlant, setNewEquipmentPlant] = useState<any>("");
    const [plants, setPlants] = useState<any>([]);
    const [selectedId, setSelectedId] = useState<number>(0);

    const [isSearchModalVisible, setSearchModalVisible] = useState(false);
    const [isFilterModalVisible, setFilterModalVisible] = useState(false);

    const [showEditEquipment, setShowEditEquipment] = useState(false);
    const { equipment, fetchEquipmentByUniqueCode } = useGetEquipmentByUniqueCode();

    const [editDisabled, setEditDisabled] = useState(true);

    const [localEquipmentPlantUniqueCode, setLocalEquipmentPlantUniqueCode] = useState("");
    const [localEquipmentClientUniqueCode, setLocalEquipmentClientUniqueCode] = useState("");
    const [localEquipmentDispenserCode, setLocalEquipmentDispenserCode] = useState("");
    const [localEquipmentAgitatorCode, setLocalEquipmentAgitatorCode] = useState("");
    const [localEquipmentTankCode, setLocalEquipmentTankCode] = useState("");
    const [localEquipmentControllerCode, setLocalEquipmentControllerCode] = useState("");
    const [localEquipmentAdditiveCode, setLocalEquipmentAdditiveCode] = useState("");

    const {updateEquipmentByUniqueCode, updatingEquipment} = useUpdateEquipment();


    useEffect(() => {
        if (equipment) {
            setLocalEquipmentClientUniqueCode(setLocalEquipmentAndPlantsByPlantUniqueCode(equipment.plantUniqueCode));
            setLocalEquipmentPlantUniqueCode(equipment.plantUniqueCode);
            setLocalEquipmentDispenserCode(equipment.dispenserUniqueCode);
            setLocalEquipmentAgitatorCode(equipment.agitatorUniqueCode);
            setLocalEquipmentTankCode(equipment.tankUniqueCode);
            setLocalEquipmentControllerCode(equipment.controllerUniqueCode);
            setLocalEquipmentAdditiveCode(equipment.additiveUniqueCode);
        }
    }, [equipment]);

    const setLocalEquipmentAndPlantsByPlantUniqueCode = (plantUniqueCode: string): string => {
        const clientName: string = findClientByPlantKey(plantUniqueCode);
        setSelectedClient(clientName);
        const selectedClient: any = clients[clientName];
        setPlants(selectedClient);
        return clientName;
    };


    useEffect(() => {
        const isDisabled = !newEquipmentDispenser || !newEquipmentAdditives;
        setIsConfirmDisabled(isDisabled);
    }, [newEquipmentDispenser, newEquipmentAdditives]);



    const findClientByPlantKey = (plantUniqueCode: string) => {
        for (const client in clients) {
            if (clients[client].hasOwnProperty(plantUniqueCode)) {
                return client;
            }
        }
        return "";
    }

    const handleLocalClientChange = (event:any) => {
        setLocalEquipmentPlantUniqueCode("");
        const selectedKey = event.target.value;
        setLocalEquipmentClientUniqueCode(selectedKey);
        const selectedClient: any = clients[selectedKey];
        setPlants(selectedClient);
    }

    const handleClientChange = (event: any) => {
        setNewEquipmentPlant("");
        const selectedKey = event.target.value;
        setSelectedClient(selectedKey);
        const selectedClient: any = clients[selectedKey];
        setPlants(selectedClient);
    };

    const handleAddEquipment = () => {
        setShowEditEquipment(false);
        setShowAddEquipment(true);
    }

    const clearFields = () => {
        setNewEquipmentDispenser("");
        setNewEquipmentController("");
        setNewEquipmentAgitator("");
        setNewEquipmentTank("");
        setNewEquipmentAdditives("");
        setNewEquipmentPlant("");
        setSelectedClient("");
    }


    const handleSearchModal = (uniqueCode: string) => {
        setFilters({uniqueCode});
    };

    const handleCloseFilterModal = () => {
        setFilterModalVisible(false);
    }

    const handleResetClientsTable = () => {
        setFilters({});
        setPage(0);
        setEditDisabled(true);
        setShowAddEquipment(false);
        setShowEditEquipment(false);
    };

    const handleOnRowClick = (row: Record<string, any>) => {
        clearFields()
        setShowAddEquipment(false);
        setShowEditEquipment(true);
        setSelectedId(row.ID);
        fetchEquipmentByUniqueCode(row.ID);
    };

    const validateField = (field: any, regex: any, errorMessage: any) => {
        if (!regex.test(field)) {
            toast.error(errorMessage, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return false;
        }
        return true;
    };


    const handleUpdate = () => {

        if(localEquipmentClientUniqueCode !== "" && localEquipmentPlantUniqueCode === ""){
            toast.error("No puede seleccionar un cliente sin seleccionar una planta también.", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        if(localEquipmentDispenserCode === ""){
            toast.error("Un dosificador es obligatorio.", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        const updatedEquipment = {
            plantUniqueCode: localEquipmentPlantUniqueCode,
            additiveUniqueCode: localEquipmentAdditiveCode,
            controllerUniqueCode: localEquipmentControllerCode,
            tankUniqueCode: localEquipmentTankCode,
            dispenserUniqueCode: localEquipmentDispenserCode,
            agitatorUniqueCode: localEquipmentAgitatorCode
        }

        updateEquipmentByUniqueCode(updatedEquipment,selectedId).then(response => {
            toast.success('¡Equipo actualizado correctamente!', {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });

            updateEquipmentLocally(response);
            setShowEditEquipment(false);
            setEditDisabled(true);

        }).catch(error => {
            toast.error(error.response.data.message, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
        })

    }

    const handleNewEquipment = (e: React.FormEvent) => {
        e.preventDefault();

        const newEquipment = {
            plantUniqueCode: newEquipmentPlant,
            additiveUniqueCode: newEquipmentAdditives,
            controllerUniqueCode: newEquipmentController,
            tankUniqueCode: newEquipmentTank,
            dispenserUniqueCode: newEquipmentDispenser,
            agitatorUniqueCode: newEquipmentAgitator
        }

        saveNewEquipment(newEquipment).then((response: any) => {
                toast.success('¡Equipo creado correctamente!', {
                    position: 'top-right',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    theme: 'colored',
                    transition: Bounce,
                });
                addEquipmentLocally(response);
                clearFields()
            }
        ).catch((err: any) => {
            toast.error(err, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
        })
    }

    return (
        <div className="additive-view-container">
            <div className="additive-view-left">
                <div className="additive-view-header">
                    <div className="additive-view-header-title">
                        <p>EQUIPOS DOSIFICADORES</p>
                    </div>
                    <span className="material-icons-outlined icon-unselected" onClick={handleAddEquipment}>
                        add_box
                </span>
                    <span className="material-icons-outlined icon-unselected"
                          onClick={() => setFilterModalVisible(true)}>
                        filter_alt
                </span>
                    <span className="material-icons-outlined icon-unselected" onClick={() => {
                        setSearchModalVisible(true)
                    }}>
                    search
                </span>
                    <span className="material-icons-outlined icon-unselected" onClick={handleResetClientsTable}>
                    restart_alt
                </span>
                </div>
                {isLoading ?
                    (
                        <div className="loading-overlay">
                            <div className="spinner"></div>
                            <div className="loading-message">Obteniendo información...</div>
                        </div>
                    ) : (
                        <div className="additive-table-container">
                            <Table
                                columns={columns}
                                data={equipments}
                                totalPages={totalPages}
                                currentPage={page}
                                setCurrentPage={setPage}
                                onRowClick={handleOnRowClick}
                            />
                        </div>
                    )}
            </div>
            <div className="add-additive">
                {showAddEquipment && (
                    <div className="additive-actions-container">
                        <div className="additives-view-actions-wrapper">
                            {savingNewEquipment ?
                                (
                                    <div className="loading-overlay-for-additive-view">
                                        <div className="spinner"></div>
                                        <div className="loading-message">Guardando</div>
                                    </div>
                                ) :
                                (
                                    <div>
                                        <div className="additive-view-header">
                                            <div className="additive-view-header-title">
                                                <p>AÑADIR EQUIPO</p>
                                            </div>
                                        </div>
                                        <form className="add-equipment-form" onSubmit={handleNewEquipment}>
                                            <div className="form-item">
                                                <label htmlFor="clienteDropdown">CLIENTE</label>
                                                <select
                                                    id="clienteDropdown"
                                                    value={selectedClient}
                                                    onChange={handleClientChange}
                                                >
                                                    <option value="">Seleccione un cliente</option>
                                                    {clients && Object.keys(clients).length > 0 ? (
                                                        Object.keys(clients).map((clientKey) => (
                                                            <option key={clientKey} value={clientKey}>
                                                                {clientKey}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option value="" disabled>
                                                            No hay clientes disponibles
                                                        </option>
                                                    )}
                                                </select>
                                            </div>

                                            <div className="form-item">
                                                <label htmlFor="plantaDropdown">PLANTA</label>
                                                <select
                                                    id="plantaDropdown"
                                                    value={newEquipmentPlant}
                                                    onChange={(e) => setNewEquipmentPlant(e.target.value)}
                                                    disabled={!selectedClient || !plants || Object.keys(plants).length === 0}
                                                >
                                                    <option value="">Seleccione una planta</option>
                                                    {plants && Object.entries(plants).length > 0 ? (
                                                        Object.entries(plants).map(([key, value]: any) => (
                                                            <option key={key} value={key}>
                                                                {value}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option value="" disabled>
                                                            No hay plantas disponibles
                                                        </option>
                                                    )}
                                                </select>
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="dispenserDropdown">DOSIFICADOR *</label>
                                                <select
                                                    id="dispenserDropdown"
                                                    value={newEquipmentDispenser}
                                                    onChange={(e) => setNewEquipmentDispenser(e.target.value)}
                                                >
                                                    <option value="">Seleccione un dosificador</option>
                                                    {dispenser && Object.entries(dispenser).length > 0 ? (
                                                        Object.entries(dispenser).map(([key, value]: any) => (
                                                            <option key={key} value={key}>
                                                                {value}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option value="" disabled>
                                                            No hay dosificadores disponibles
                                                        </option>
                                                    )}
                                                </select>
                                            </div>

                                            <div className="form-item">
                                                <label htmlFor="controllerDropdown">CONTROLADOR</label>
                                                <select
                                                    id="controllerDropdown"
                                                    value={newEquipmentController}
                                                    onChange={(e) => setNewEquipmentController(e.target.value)}
                                                >
                                                    <option value="">Seleccione un controlador</option>
                                                    {controller && Object.entries(controller).length > 0 ? (
                                                        Object.entries(controller).map(([key, value]: any) => (
                                                            <option key={key} value={key}>
                                                                {value}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option value="" disabled>
                                                            No hay controladores disponibles
                                                        </option>
                                                    )}
                                                </select>
                                            </div>

                                            <div className="form-item">
                                                <label htmlFor="agitatorDropdown">AGITADOR</label>
                                                <select
                                                    id="agitatorDropdown"
                                                    value={newEquipmentAgitator}
                                                    onChange={(e) => setNewEquipmentAgitator(e.target.value)}
                                                >
                                                    <option value="">Seleccione un agitador</option>
                                                    {agitator && Object.entries(agitator).length > 0 ? (
                                                        Object.entries(agitator).map(([key, value]: any) => (
                                                            <option key={key} value={key}>
                                                                {value}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option value="" disabled>
                                                            No hay agitadores disponibles
                                                        </option>
                                                    )}
                                                </select>
                                            </div>

                                            <div className="form-item">
                                                <label htmlFor="tankDropdown">TANQUE</label>
                                                <select
                                                    id="tankDropdown"
                                                    value={newEquipmentTank}
                                                    onChange={(e) => setNewEquipmentTank(e.target.value)}
                                                >
                                                    <option value="">Seleccione un tanque</option>
                                                    {tank && Object.entries(tank).length > 0 ? (
                                                        Object.entries(tank).map(([key, value]: any) => (
                                                            <option key={key} value={key}>
                                                                {value}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option value="" disabled>
                                                            No hay tanques disponibles
                                                        </option>
                                                    )}
                                                </select>
                                            </div>

                                            <div className="form-item">
                                                <label htmlFor="additiveDropdown">ADITIVO *</label>
                                                <select
                                                    id="additiveDropdown"
                                                    value={newEquipmentAdditives}
                                                    onChange={(e) => setNewEquipmentAdditives(e.target.value)}
                                                >
                                                    <option value="">Seleccione un aditivo</option>
                                                    {additives && Object.entries(additives).length > 0 ? (
                                                        Object.entries(additives).map(([key, value]: any) => (
                                                            <option key={key} value={key}>
                                                                {value}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option value="" disabled>
                                                            No hay aditivos disponibles
                                                        </option>
                                                    )}
                                                </select>
                                            </div>
                                            <div className="bottom">
                                                <p>* Campos obligatorios</p>
                                                <div className="buttons">
                                                    <button type="button" className="cancel" onClick={clearFields}>
                                                        Cancelar
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        className={`confirm ${isConfirmDisabled ? 'disabled' : ''}`}
                                                        disabled={isConfirmDisabled}
                                                    >
                                                        Guardar
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                )}

                {updatingEquipment ? (
                    <div className="loading-overlay-for-additive-view">
                        <div className="spinner"></div>
                        <div className="loading-message">Guardando</div>
                    </div>) : (
                    <div>
                        {showEditEquipment && (
                            <div>
                                <div className="plants-info-view-header">
                                    <div className="plants-info-view-header-title">
                                        <p>ASIGNADOS</p>
                                    </div>
                                    <span
                                        className={`material-icons-outlined icon-unselected ${
                                            !editDisabled ? "active-edit" : ""
                                        }`}
                                        onClick={() => setEditDisabled(!editDisabled)}
                                    >
                                edit
                            </span>
                                </div>
                                <div className="plants-info-fields">
                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">CLIENTE</div>
                                        {editDisabled ? (
                                            <input
                                                className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                                type="text"
                                                value={localEquipmentClientUniqueCode}
                                                disabled={editDisabled}
                                            />
                                        ) : (
                                            <select
                                                className="value-label"
                                                value={localEquipmentClientUniqueCode}
                                                onChange={handleLocalClientChange}
                                            >
                                                <option value=""></option>
                                                {clients && Object.keys(clients).length > 0 ? (
                                                    Object.keys(clients).map((clientKey) => (
                                                        <option key={clientKey} value={clientKey}>
                                                            {clientKey}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="" disabled>
                                                        No hay clientes disponibles
                                                    </option>
                                                )}
                                            </select>
                                        )}
                                    </div>

                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">PLANTA</div>
                                        {editDisabled ? (
                                            <input
                                                className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                                type="text"
                                                value={localEquipmentPlantUniqueCode}
                                                disabled={editDisabled}
                                                onChange={(e) => setLocalEquipmentPlantUniqueCode(e.target.value)}
                                            />
                                        ) : (
                                            <select
                                                id="plantaDropdown"
                                                className="value-label"
                                                value={localEquipmentPlantUniqueCode}
                                                onChange={(e) => setLocalEquipmentPlantUniqueCode(e.target.value)}
                                                disabled={!localEquipmentClientUniqueCode || !plants || Object.keys(plants).length === 0}
                                            >
                                                <option value=""></option>
                                                {plants && Object.entries(plants).length > 0 ? (
                                                    Object.entries(plants).map(([key, value]: any) => (
                                                        <option key={key} value={key}>
                                                            {value}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="" disabled>
                                                        No hay plantas disponibles
                                                    </option>
                                                )}
                                            </select>
                                        )}
                                    </div>

                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">DOSIFICADOR</div>
                                        {editDisabled ? (
                                            <input
                                                className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                                type="text"
                                                value={localEquipmentDispenserCode}
                                                disabled={editDisabled}
                                                onChange={(e) => setLocalEquipmentDispenserCode(e.target.value)}
                                            />
                                        ) : (
                                            <select
                                                className="value-label"
                                                value={localEquipmentDispenserCode}
                                                onChange={(e) => setLocalEquipmentDispenserCode(e.target.value)}
                                            >
                                                <option value=""></option>
                                                {dispenser && Object.entries(dispenser).length > 0 ? (
                                                    Object.entries(dispenser).map(([key, value]: any) => (
                                                        <option key={key} value={key}>
                                                            {value}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="" disabled>
                                                        No hay dosificadores disponibles
                                                    </option>
                                                )}
                                            </select>
                                        )}
                                    </div>

                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">AGITADOR</div>
                                        {editDisabled ? (
                                            <input
                                                className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                                type="text"
                                                value={localEquipmentAgitatorCode}
                                                disabled={editDisabled}
                                                onChange={(e) => setLocalEquipmentAgitatorCode(e.target.value)}
                                            />
                                        ) : (
                                            <select
                                                className="value-label"
                                                value={localEquipmentAgitatorCode}
                                                onChange={(e) => setLocalEquipmentAgitatorCode(e.target.value)}
                                            >
                                                <option value=""></option>
                                                {agitator && Object.entries(agitator).length > 0 ? (
                                                    Object.entries(agitator).map(([key, value]: any) => (
                                                        <option key={key} value={key}>
                                                            {value}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="" disabled>
                                                        No hay agitadores disponibles
                                                    </option>
                                                )}
                                            </select>
                                        )}
                                    </div>

                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">CONTROLADOR</div>
                                        {editDisabled ? (
                                            <input
                                                className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                                type="text"
                                                value={localEquipmentControllerCode}
                                                disabled={editDisabled}
                                                onChange={(e) => setLocalEquipmentControllerCode(e.target.value)}
                                            />
                                        ) : (
                                            <select
                                                className="value-label"
                                                value={localEquipmentControllerCode}
                                                onChange={(e) => setLocalEquipmentControllerCode(e.target.value)}
                                            >
                                                <option value=""></option>
                                                {controller && Object.entries(controller).length > 0 ? (
                                                    Object.entries(controller).map(([key, value]: any) => (
                                                        <option key={key} value={key}>
                                                            {value}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="" disabled>
                                                        No hay controladores disponibles
                                                    </option>
                                                )}
                                            </select>
                                        )}
                                    </div>

                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">TANQUE</div>
                                        {editDisabled ? (
                                            <input
                                                className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                                type="text"
                                                value={localEquipmentTankCode}
                                                disabled={editDisabled}
                                                onChange={(e) => setLocalEquipmentTankCode(e.target.value)}
                                            />
                                        ) : (
                                            <select
                                                className="value-label"
                                                value={localEquipmentTankCode}
                                                onChange={(e) => setLocalEquipmentTankCode(e.target.value)}
                                            >
                                                <option value=""></option>
                                                {tank && Object.entries(tank).length > 0 ? (
                                                    Object.entries(tank).map(([key, value]: any) => (
                                                        <option key={key} value={key}>
                                                            {value}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="" disabled>
                                                        No hay tanques disponibles
                                                    </option>
                                                )}
                                            </select>
                                        )}
                                    </div>

                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">ADITIVO</div>
                                        {editDisabled ? (
                                            <input
                                                className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                                type="text"
                                                value={localEquipmentAdditiveCode}
                                                disabled={editDisabled}
                                                onChange={(e) => setLocalEquipmentAdditiveCode(e.target.value)}
                                            />
                                        ) : (
                                            <select
                                                className="value-label"
                                                value={localEquipmentAdditiveCode}
                                                onChange={(e) => setLocalEquipmentAdditiveCode(e.target.value)}
                                            >
                                                <option value=""></option>
                                                {additives && Object.entries(additives).length > 0 ? (
                                                    Object.entries(additives).map(([key, value]: any) => (
                                                        <option key={key} value={key}>
                                                            {value}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="" disabled>
                                                        No hay aditivos disponibles
                                                    </option>
                                                )}
                                            </select>
                                        )}
                                    </div>

                                    {!editDisabled && (
                                        <div className="bottom-buttons">
                                            <button type="submit" className="confirm" onClick={handleUpdate}>
                                                Guardar
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                )}

                <SearchTicketModal
                    isVisible={isSearchModalVisible}
                    onClose={() => setSearchModalVisible(false)}
                    onSearch={handleSearchModal}
                    placeholder="Clave de equipo"
                />
                <FilterEquipmentsModal
                    isVisible={isFilterModalVisible}
                    onClose={() => setFilterModalVisible(false)}
                    onSearch={handleFilterModal}
                    clients={clients}
                    states={['Instalado', 'Creado']}
                />
            </div>
        </div>
    )
}

export default AdministrativeEquipments;